import { IntlType } from '../../../../utils/typing';

interface Props {
  intl: IntlType;
  handleClick: () => void;
  textOverride?: string;
}

const ClearFieldsButton = (props: Props): JSX.Element => {
  const { intl, handleClick, textOverride } = props;

  return (
    <button className="button inverted cancel mr-2" onClick={handleClick}>
      {textOverride || intl.formatMessage({ id: 'clearFields' })}
    </button>
  );
};

export default ClearFieldsButton;
